"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FeaturedLiteraryJourney() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="229539" id="building-from-the-bottom-up" className="relative w-full bg-background overflow-hidden py-16 md:py-24 lg:py-32 dark">
      {}
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/grid_texture.png')] bg-repeat mix-blend-overlay dark:opacity-[0.05]" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background/90 to-primary/10 pointer-events-none" aria-hidden="true" />

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={imageRef} className={`relative flex justify-center lg:justify-end transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative group">
              {}
              <div className="absolute -inset-4 bg-primary/20 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/industrial_commercial_construction_site.png" alt="Industrial and Commercial Construction Site" className="relative w-full h-auto max-w-[280px] sm:max-w-sm md:max-w-md lg:max-w-[420px] rounded-sm shadow-2xl shadow-black/50 object-cover aspect-[2/3] transition-transform duration-700 group-hover:scale-[1.02] grayscale-[0.2] contrast-125" />
            </div>
          </div>

          {}
          <div ref={contentRef} className={`flex flex-col items-start text-left max-w-xl transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <Badge variant="secondary" className="mb-6 uppercase tracking-widest text-xs font-mono font-semibold bg-primary/10 text-primary border-primary/20 backdrop-blur-sm px-3 py-1 rounded-sm">
              Licensed & Insured Construction
            </Badge>
            
            <h1 className="font-default text-4xl sm:text-6xl lg:text-7xl font-black text-white leading-[0.95] mb-6 tracking-tighter uppercase">
              Building From the Bottom Up
            </h1>
            
            <p className="font-default text-lg sm:text-xl text-muted-foreground leading-relaxed mb-10">
              Specialising in commercial and industrial fitouts, refurbishments, and remedial works. We deliver high-quality solutions across offices, warehouses, and retail developments with precision.
            </p>
            
            <Link to="https://set-starfish.10web.cloud/contact/">
              <Button size="lg" className="group relative overflow-hidden h-14 px-8 text-base bg-primary text-primary-foreground rounded-sm shadow-lg shadow-primary/20 hover:bg-primary/90 transition-all duration-300">
                <span className="relative z-10 flex items-center gap-2 font-bold tracking-wider uppercase">
                  Start Your Project 
                  <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1.5" />
                </span>
                {}
                <div className="absolute inset-0 -translate-x-[150%] bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12 transition-transform duration-1000 ease-in-out group-hover:translate-x-[150%]" aria-hidden="true" />
              </Button>
            </Link>
          </div>

        </div>
      </div>
    </section>;
}